<template>
    <div id="contenedor-default-contrato" class="bkground">
      <v-skeleton-loader v-if="$apollo.loading" type="card"></v-skeleton-loader>
      <v-card v-else flat>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  NÚMERO DE CONTRATO
                </span>
              </div>
              <div>
                <span> {{ getContrato.numero }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  ¿CÓMO SE CONTRATÓ?
                </span>
              </div>
              <div>
                <span> {{ getContrato.comoSeContrato }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  CONTRATISTA
                </span>
              </div>
              <div>
                <span> {{ getContrato.contratista.nombreRazonSocial }} </span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  OBJETO
                </span>
              </div>
              <div>
                <span> {{ getContrato.meta }} </span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  FECHA DE CONTRATO
                </span>
              </div>
              <div>
                <span> {{ $moment(getContrato.fecha).format('DD/MM/YYYY') }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  FECHA DE INICIO
                </span>
              </div>
              <div>
                <span> {{ $moment(getContrato.fechaInicio).format('DD/MM/YYYY') }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  FECHA DE TERMINO
                </span>
              </div>
              <div>
                <span> {{ $moment(getContrato.fechaTermino).format('DD/MM/YYYY') }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  ¿ES OBRA FINANCIADA?
                </span>
              </div>
              <div>
                <span> {{ getContrato.esObraFinanciada ? 'SI' : 'NO' }} </span>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="getContrato.esObraFinanciada">
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  IMPORTE COSTO DIRECTO
                </span>
              </div>
              <div>
                <span> {{ getContrato.importeCostoDirecto | currency }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  PORCENTAJE INDIRECTOS
                </span>
              </div>
              <div>
                <span> {{ getContrato.porcentajeCostoIndirectos }} % </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  IMPORTE INDIRECTOS
                </span>
              </div>
              <div>
                <span> {{ getContrato.importeCostoIndirectos | currency }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  PORCENTAJE DE UTILIDAD
                </span>
              </div>
              <div>
                <span> {{ getContrato.porcentajeUtilidad }} % </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  IMPORTE DE UTILIDAD
                </span>
              </div>
              <div>
                <span> {{ getContrato.importeUtilidad | currency }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  PORCENTAJE ADICIONALES
                </span>
              </div>
              <div>
                <span> {{ getContrato.porcentajeCargosAdicionales }} % </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  IMPORTE ADICIONALES
                </span>
              </div>
              <div>
                <span> {{ getContrato.importeCargosAdicionales | currency }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  PORCENTAJE COSTO FINANCIERO
                </span>
              </div>
              <div>
                <span> {{ getContrato.porcentajeCostoFinanciero }} % </span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  {{ getContrato.importeTotal | currency }}
                </span>
              </div>
              <div>
                <span>IMPORTE SIN FINANCIAMIENTO</span>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  IMPORTE COSTO FINANCIERO
                </span>
              </div>
              <div>
                <span> {{ getContrato.importeCostoFinanciero | currency }} </span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  IMPORTE
                </span>
              </div>
              <div>
                <span> {{ getContrato.importe | currency }} </span>
              </div>
              </v-col>
              <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  IVA
                </span>
              </div>
              <div>
                <span> {{ getContrato.iva | currency }} </span>
              </div>
              </v-col>
              <v-col cols="12" md="3">
              <div>
                <span class="secondary--text font-weight-bold" cols="12">
                  TOTAL
                </span>
              </div>
              <div>
                <span> {{ getContrato.total | currency }} </span>
              </div>
            </v-col>
          </v-row>
          <!-- Estatus y etiquetas -->
          <v-divider></v-divider>
          <v-row>
            <v-col
              cols="12"
              md="4">
              <div class="mb-2">
                <span class="secondary--text font-weight-bold">
                  ESTATUS DEL CONTRATO
                </span>
              </div>
              <div>
                <actualizar-estatus
                  v-if="mixValidaScopesActions(2)"
                  :id-contrato="getContrato.id"
                  :estatus="getEstatus"
                  :id-contrato-estatus="getContrato.idContratoEstatus">
                </actualizar-estatus>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <div class="mb-2">
                <span class="secondary--text font-weight-bold">
                  ETIQUETAS
                </span>
              </div>
              <div>
                <v-row>
                  <template
                    v-for="{id, etiqueta} in getContrato.etiquetas">
                    <template>
                      <v-col
                        :key="id"
                        cols="auto">
                        <v-chip
                          :color="etiqueta.color"
                          :dark="etiqueta.esTextoClaro">
                          {{ etiqueta.nombre }}
                        </v-chip>
                      </v-col>
                    </template>
                  </template>
                  <v-col
                    cols="auto">
                    <agregar-etiquetas
                      v-if="mixValidaScopesActions(2)"
                      :id-referencia="getContrato.id"
                      :etiquetas-agregadas="getContrato.etiquetas
                      .map(({idEtiqueta}) => idEtiqueta)">
                    </agregar-etiquetas>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-row
                no-gutters
                align="center">
                <v-col>
                  <span class="secondary--text font-weight-bold">
                    UBICACIONES
                  </span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-tooltip top>
                    <template
                      v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="mostrarAgregarUbicacion = !mostrarAgregarUbicacion"
                        icon
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Agregar nueva ubicación
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <ubicaciones
                :id-contrato="$route.params.idContrato">
              </ubicaciones>
            </v-col>
          </v-row>
          <div>
          <v-divider></v-divider>
          <v-row class="mt-4">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                OBRAS:
              </span>
            </div>
          </v-row>
          <v-data-table
            v-if="getContrato.obras.length > 0"
            :headers="headers"
            :items="getContrato.obras"
            disable-pagination
            disable-filtering
            hide-default-footer>
          <template v-slot:[`item.obra.tipo`]="{ item }">
            <v-chip :color="item.obra.tipo.color">
              <span>
                {{item.obra.tipo.descripcion}}
              </span>
            </v-chip>
          </template>
          </v-data-table>
          <span v-else>Este contrato no tiene obras registradas.</span>
        </div>
        </v-card-text>
      </v-card>
      <v-dialog
        v-model="mostrarAgregarUbicacion"
        width="650"
        persistent>
        <agregar-ubicaciones
          :id-contrato="$route.params.idContrato"
          v-on:cerrar="cerrarAgregarGeolocalizacion">
        </agregar-ubicaciones>
      </v-dialog>
    </div>
</template>

<script>

import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import ActualizarEstatus from '@/components/administracion/contratos/contrato/ActualizarEstatus.vue';
import AgregarEtiquetas from '@/components/administracion/etiquetas/Agregar.vue';
import AgregarUbicaciones from '@/components/administracion/contratos/contrato/ubicaciones/Agregar.vue';
import Ubicaciones from './Ubicaciones.vue';

export default {
  name: 'DefaultContrato',
  components: {
    ActualizarEstatus,
    AgregarEtiquetas,
    AgregarUbicaciones,
    Ubicaciones,
  },
  data() {
    return {
      mostrarAgregarUbicacion: false,
      headers: [
        {
          text: 'Clave',
          class: 'secondary--text font-weight-bold',
          align: 'start',
          value: 'obra.clave',
          width: '115',
          sortable: false,
        },
        {
          text: 'Tipo', class: 'secondary--text font-weight-bold', value: 'obra.tipo.descripcion', sortable: false,
        },
        {
          text: 'Meta', class: 'secondary--text font-weight-bold', value: 'obra.meta', sortable: false,
        },
      ],
    };
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    cerrarAgregarGeolocalizacion() {
      this.mostrarAgregarUbicacion = false;
    },
    formatoFecha(fecha) {
      return new Date(`${fecha} 00:00:0`).toLocaleDateString();
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getEstatus() {
      if (!this.contrato.estatus) return {};
      return this.contrato.estatus;
    },
  },
};
</script>

<style lang="scss">

</style>
